import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import scrollToTop from "@assets/images/scroll-to-top-icon.svg";
import MyTypography from "@saleor/components/MyTypography";
import SingleSelectField from "@saleor/components/SingleSelectField";
import {
  useGetRolesAndMenuFunctionsQuery,
  useParentGroupsQuery
} from "@saleor/graphql";
import useLocalStorage from "@saleor/hooks/useLocalStorage";
import { makeStyles } from "@saleor/macaw-ui";
import UserGuideTable from "@saleor/userManagement/components/UserGuideTable";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef } from "react";

const useStyles = makeStyles(
  theme => ({
    content: {
      height: "100%",
      margin: "0 10px 100px 10px",
      position: "relative",
      [theme.breakpoints.up("md")]: {
        margin: "0 200px 100px 200px"
      }
    },
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "40px auto 20px auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      transition: "all 0.5s ease",
      [theme.breakpoints.up("md")]: {
        margin: "20px 0px 10px 30px",
        flexDirection: "row"
      }
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 10,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17",
      [theme.breakpoints.down("sm")]: {
        borderRight: "none",
        borderBottom: "solid 1px #E41B17",
        padding: "5px 0"
      }
    },
    inputField: {
      margin: "20px auto",
      width: "100%",
      maxWidth: "300px",
      [theme.breakpoints.up("md")]: {
        margin: "0px 50px 0px 0px",
        maxWidth: "180px"
      }
    },
    logo: {
      marginLeft: 0,
      marginTop: 10,
      [theme.breakpoints.up("md")]: {
        marginLeft: 20,
        marginTop: 0
      }
    },
    selectInputBox: {
      height: "36px",
      maxWidth: "180px",
      marginTop: "0px",
      "& .MuiSelect-root": {
        padding: "1.2rem",
        color: theme.palette.grey[800]
      }
    },
    selectHead: {
      fontSize: "12px"
    },
    itemAlign: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        justifyContent: "space-between"
      }
    },
    scrollToTopButton: {
      position: "fixed",
      bottom: "90px",
      right: "140px",
      cursor: "pointer",
      background: "transparent",
      border: "none"
    }
  }),
  { name: "UserRoleGuide" }
);

const UserRoleGuide = () => {
  const classes = useStyles();
  const tableContainerRef = useRef(null);
  const [userGuidanceData, setUserGuidanceData] = useLocalStorage(
    "userGuidanceData",
    null
  );

  const formikGuide = useFormik({
    initialValues: {
      userGroup: "0"
    },
    onSubmit: () => {
      //
    }
  });

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userGuidanceData"));
    const isSessionExpired =
      !storedData?.expiredTime || new Date().getTime() > storedData.expiredTime;
    if (isSessionExpired) {
      localStorage.removeItem("userGuidanceData");
      setUserGuidanceData(null);
    } else if (storedData) {
      setUserGuidanceData(storedData);
    }
  }, []);

  const { data: parentGroupData } = useParentGroupsQuery();
  const { data: fetchUserGuidanceData } = useGetRolesAndMenuFunctionsQuery({
    variables: {},
    skip: userGuidanceData !== null
  });

  useEffect(() => {
    if (
      userGuidanceData === null &&
      fetchUserGuidanceData?.getRolesAndMenuFunctions
    ) {
      const expirationTime = new Date().getTime() + 3600000;
      setUserGuidanceData({
        data: fetchUserGuidanceData,
        expiredTime: expirationTime
      });
    }
  }, [fetchUserGuidanceData]);

  const groupChoices = useMemo(() => {
    const groupList =
      parentGroupData?.parentGroups?.edges.map(({ node }) => ({
        label: node.name,
        value: node.id,
        code: node.code
      })) || [];
    groupList.unshift({ label: "All", value: "0", code: "ALL" });
    return groupList;
  }, [parentGroupData]);

  const handleScrollToTop = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  return (
    <div>
      <div className={classes.content}>
        <div className={classes.mainPanel}>
          <div className={classes.itemAlign}>
            <div className={classes.headTextLogo}>
              <div className={classes.text}>
                <img src={SCGP_Color} alt={"logo_scg"} width="42px" />
              </div>
              <div className={classes.logo}>
                <img src={EOrderingLogo} alt={"logo"} width="110px" />
              </div>
            </div>
            <div className={classes.inputField}>
              <MyTypography
                variant={"subtitle3"}
                className={classes.selectHead}
              >
                Filter by User Group
              </MyTypography>
              <SingleSelectField
                noScrollBar
                className={classes.selectInputBox}
                choices={groupChoices}
                onChange={formikGuide.handleChange}
                placeholder={"เลือก User Group"}
                value={formikGuide?.values?.userGroup}
                name={"userGroup"}
              />
            </div>
          </div>
          <div>
            <UserGuideTable
              formik={formikGuide}
              userGroupList={groupChoices}
              tableContainerRef={tableContainerRef}
              userGuidanceData={userGuidanceData?.data}
            />
          </div>
        </div>
      </div>
      {formikGuide?.values?.userGroup === "0" && (
        <button
          className={classes.scrollToTopButton}
          onClick={handleScrollToTop}
        >
          <img src={scrollToTop} alt="Scroll to top" width="50px" />
        </button>
      )}
    </div>
  );
};

export default UserRoleGuide;
